import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/9038ce07-0798-4c01-af9c-26bdd22d8851";
export const REGISTER_URL = "https://a.ntrk2.com/a0733363-1aef-440c-8479-85309ff1777c";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://789xyz.kzw2a.com/download?id=5umv8n8v2iq4vno";

export * from "./codes";
export * from "./context";
